import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { pick } from 'Helpers/Affordances';
import AutomationSuggestions from './AutomationSuggestions';

const AutomationSuggestionsPicker = ({ tabResource }) => {
  return pick(tabResource, {
    [fr.relationships.tabData.name]: <AutomationSuggestions
      tabDataRelationship={tabResource?.relationship(fr.relationships.tabData.name)}
    />,
  }, () => null);
};

AutomationSuggestionsPicker.propTypes = {
  tabResource: PropTypes.object.isRequired,
};

export default AutomationSuggestionsPicker;
